<template>
  <div class="saveBottom">
    <div class="record">{{ record }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      record: 'Copyright © 2024 Danghuan Technology Private Limited.All Rights Reserved'
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  created() {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media (max-width: 980px) {
  .saveBottom {
    // background: #f2f5f8;
    position: fixed;
    bottom: 0;
    font-size: 18px;
    width: 100%;
    .record {
      width: 100%;
      display: block;
      box-sizing: border-box;
      color: #999;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #fff;
      border-top: 1px solid #D9D9D9;
    }
    @supports (bottom: env(safe-area-inset-bottom)) or (bottom: constant(safe-area-inset-bottom)) {
      .record {
        margin-bottom: env(safe-area-inset-bottom);
        margin-bottom: constant(safe-area-inset-bottom);
      }
    }
  }
}
@media (min-width: 981px) {
  .saveBottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    .save {
      width: 100%;
      height: 180px;
      background: #272727;
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      justify-content: center;
      .save-item {
        width: 300px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 42px;
          height: 42px;
          margin-right: 8px;
        }
        span {
          color: white;
          font-size: 26px;
        }
      }
    }
    .info {
      width: 1200px;
      padding: 37px 0;
      display: flex;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      .infos {
        width: 100%;
        box-sizing: border-box;
        .infos-bottom {
          display: flex;
          margin-top: 36px;
        }

        .phone-info {
          display: flex;
          align-items: flex-start;
          margin-right: 60px;
          &:last-child {
            margin-right: 0;
          }
          .info-text {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            span {
              font-size: 16px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #777777;
              line-height: 24px;
            }
            .phone {
              margin-top: 16px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #333333;
              line-height: 24px;
            }
            .support-text{
              margin-top: 8px;
            }
          }
        }

        .button-wrappr {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex: 1;
          .button {
            height: 60px;
            color: white;
            background: #ff9600;
            border-radius: 35px;
            display: flex;
            align-items: center;
            cursor: pointer;
            font-size: 22px;
            padding: 0 35px;
            img {
              width: 40px;
              height: 40px;
              margin-right: 7px;
            }
          }
        }
      }
    }
    .record {
      width: 900px;
      padding: 24px 0;
      margin: 0 auto;
      font-size: 12px;
      color: #999;
      border-top: 1px solid #D9D9D9;
    }
  }
}
.emil {
  color: #3b89e0 !important;
  text-align: left;
}
</style>
